import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class ChangePasswordValidator {
  static validate(changePasswordFormGroup: UntypedFormGroup) {
    const condition =
      changePasswordFormGroup.get('password').value !==
      changePasswordFormGroup.get('repeatPassword').value;

    return condition ? { passwordsDoNotMatch: true } : null;
  }
}

/** Errore quando il parent non è valido */
export class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control.dirty || control.touched) && form.invalid;
  }
}
